<template lang="">
    <div class=' flex flex-col sticky top-3/4 lg:top-1/4 lg:p-3 lg:w-full'>
        <div class='logo'>
             </div>
        <div class="flex navItem  p-2  gap-3 items-center rounded bg-site-primary hover:bg-site-secondary hover:cursor-pointer hover:text-white " >
            <v-icon class="icon flex justify-start" scale="1.5" name="io-home" />
            <div class='justify-center hidden lg:flex'> Dashboard </div>
            
        </div>
        <div class="flex navItem  p-2  gap-3 items-center rounded bg-site-primary hover:bg-site-secondary hover:cursor-pointer hover:text-white" >
            <v-icon class="icon flex justify-start" scale="1.5" name="bi-bar-chart-steps" />
            <div class=' hidden lg:flex justify-center'> Tools </div>
        </div>
        <div class="flex navItem  p-2  gap-3 items-center rounded bg-red-300  hover:bg-red-500 hover:cursor-pointer hover:text-white" @click="logoutFunction" >
            <v-icon class="icon flex justify-start" scale="1.5" name="io-exit-outline" />
            <div class='hidden lg:flex justify-center'> Log out </div>
        </div>
    </div>

</template>
<script setup>
import { logout } from '@/services/UserService';



async function logoutFunction() {
    await logout();

    location.reload();
    

    

}

</script>
<style lang="css">
body{
    
 
}

.navItem{

width: 100%;
height: 5vh; 
}


</style>